<template>
  <div class="page-content">




    <v-row>
      <v-col cols="12" sm="12" >
        <h1 class="page-title"> <span >Affiliate tracking</span></h1>

      </v-col>

    </v-row>

    <v-row style="width:100%;margin-bottom:20px;">
      <v-col cols="12"
             class="flex d-inline-flex flex-wrap justify-center mb-6"

      >
        <v-col   v-for="stat in statsType"
                 :key="stat.title">
          <v-card
                  class="pa-2 stats-card "
                  style="border:5px;"


          >
            <div class="card-body "><!----><!----><div class="row"><div class="col"><h5 class="card-title text-uppercase text-muted mb-0">{{stat.title}}</h5><span class="h2 font-weight-bold mb-0">924</span></div><div class="col-auto"><div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green"><i class="ni ni-money-coins"></i></div></div></div>
              <p class="mt-3 mb-0 text-sm"><span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span><span class="text-nowrap">Since last month</span></p>
            </div>
          </v-card>
        </v-col>
      </v-col>
    </v-row>

    <v-row style="width:100%;margin-bottom:20px;">
      <v-col cols="12"
             class="flex d-inline-flex flex-wrap justify-center mb-6"

      >
        <line-chart  :chart-data="[1,4,1,6,4,3,2,1]"></line-chart>
      </v-col>
    </v-row>


    <v-row style="margin-bottom:40px;">



      <v-row style="width:100%;margin-bottom:20px;">
        <v-col cols="12"
               class="flex d-inline-flex flex-wrap justify-center mb-6"

        >
          <v-col v-for="table in tables"
                 :key="table.title">
            <h3>{{table.title}}</h3>
            <v-simple-table class="elevation-1">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Date
                  </th>
                  <th class="text-left">
                    ID
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in table.items"
                        :key="item.name"
                >
                  <td>{{ item.date }}</td>
                  <td>{{ item.uniqueId }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-col>
      </v-row>





    </v-row>

  </div>
</template>

<style>

  .stats-card {

    height:120px;
    color:#fff;
    padding:0px 5px;

  }
  .gradient-box {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 90%;
    margin: auto;
    max-width: 22em;
    position: relative;
    padding: 30% 2em;
    box-sizing: border-box;
    color: #FFF;
    background: #000;
    background-clip: padding-box;
    /* !importanté */
    border: solid 5px transparent;
    /* !importanté */
    border-radius: 1em;
  }
  .gradient-box:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -5px;
    /* !importanté */
    border-radius: inherit;
    /* !importanté */
    background: -webkit-gradient(linear, left top, right top, from(red), to(orange));
    background: linear-gradient(to right, red, orange);
  }
  .muted-title{
    color:#ceceec;
  }

  .overline{
    color:#8898aa;
  }

  .childWrap {
    /*float: left;*/

    /*background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%)!important;*/
  }




  .text-action {

    color: #EF44AE;
    background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }

  .page-title {
    font-weight:300;font-size:27px;margin-top:5px;margin-bottom:15px;
  }

  .mobile .page-title {
    text-align: center;
  }

</style>

<script>

  import LineChart from "../components/lineChart";
  export default {
    name: 'AffiliateDashboard',
    components: {LineChart},

    data: () => ({
        data: {

            overview: {
                registered: 240,
                subscribed: 24,
                paid: 10,
                totalRevenue: 3000,
                activeUsers: 10
            },
            charts: {
                general: {
                    registered: [1,2,4,6,3,1,3,1],
                    subscribed: [2,4,6,3,1,3,1,1],
                    paid: [2,4,6,3,1,3,1,1],
                    canceled: [2,4,6,3,1,3,1,1]
                },
                revenue: {

                }
            }

        },
      statsType: [{title: 'Registered'},{title: 'Subscribed'},{title: 'Paid'},  {title: 'Total Revenue'}, {title: 'Users connected'},],
      tables: [
        {
          title: 'Last registrations',
          items: [
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            }]
        },
        {
          title: 'Last trial start',
          items: [
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            }]
        },
        {
          title: 'Last received payment',
          items: [
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            },
            {
              date: "10/18/2020 - 4:15:41 AM",
              uniqueId: "FAWjfi2",
            }]
        }
      ]
    }),
    computed: {

    }
  };
</script>
